import React, { Component } from 'react';

export const LoadingBar = () => 
    <div className="centerall">
        <img src="/images/loading-bar.gif" />
    </div>;


// WEBPACK FOOTER //
// ./src/_components/Loadingbar.jsx